
import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';

import "./Forms.css";
// add .error to component for error state.

class Radio extends PureComponent {

	constructor(props) {
		super(props);
	}

	render() {
		const { isChecked, customDivStyle, customInputStyle, customClassName, customLabelStyle,...otherProps } = this.props
		return (
			<div className={"form-wrapper " + customClassName} style={customDivStyle || {}}>
				<input type="radio" {...otherProps} defaultChecked={isChecked} style={customInputStyle || {}} />
				<label htmlFor={this.props.id} style={customLabelStyle}> {this.props.label}</label>
			</div>
		);
	}
}
export default Radio;
